// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AgentBackupData, AgentBackupErrors, AgentBackupResponses, AgentHeartbeatData, AgentHeartbeatErrors, AgentHeartbeatResponses, AgentManifestData, AgentManifestErrors, AgentManifestResponses, AppConfigGetStatusData, AppConfigGetStatusErrors, AppConfigGetStatusResponses, BackofficeAuthAcceptInviteData, BackofficeAuthAcceptInviteErrors, BackofficeAuthAcceptInviteResponses, BackofficeAuthChangePasswordData, BackofficeAuthChangePasswordErrors, BackofficeAuthChangePasswordResponses, BackofficeAuthConfirmEmailChangeData, BackofficeAuthConfirmEmailChangeErrors, BackofficeAuthConfirmEmailChangeResponses, BackofficeAuthCreateAdminData, BackofficeAuthCreateAdminErrors, BackofficeAuthCreateAdminResponses, BackofficeAuthDeleteAdminData, BackofficeAuthDeleteAdminErrors, BackofficeAuthDeleteAdminResponses, BackofficeAuthDeletePasskeyData, BackofficeAuthDeletePasskeyErrors, BackofficeAuthDeletePasskeyResponses, BackofficeAuthDeleteTotpAuthenticatorData, BackofficeAuthDeleteTotpAuthenticatorErrors, BackofficeAuthDeleteTotpAuthenticatorResponses, BackofficeAuthDisableAdminData, BackofficeAuthDisableAdminErrors, BackofficeAuthDisableAdminResponses, BackofficeAuthDisableTwoFactorData, BackofficeAuthDisableTwoFactorErrors, BackofficeAuthDisableTwoFactorResponses, BackofficeAuthEnableAdminData, BackofficeAuthEnableAdminErrors, BackofficeAuthEnableAdminResponses, BackofficeAuthEnableTwoFactorData, BackofficeAuthEnableTwoFactorErrors, BackofficeAuthEnableTwoFactorResponses, BackofficeAuthExportAdminsData, BackofficeAuthExportAdminsErrors, BackofficeAuthExportAdminsResponses, BackofficeAuthExportsIdData, BackofficeAuthExportsIdErrors, BackofficeAuthExportsIdResponses, BackofficeAuthGenerateBackupCodesData, BackofficeAuthGenerateBackupCodesErrors, BackofficeAuthGenerateBackupCodesResponses, BackofficeAuthGeneratePasskeyRegisterOptionsData, BackofficeAuthGeneratePasskeyRegisterOptionsErrors, BackofficeAuthGeneratePasskeyRegisterOptionsResponses, BackofficeAuthGeneratePasskeySignInOptionsData, BackofficeAuthGeneratePasskeySignInOptionsErrors, BackofficeAuthGeneratePasskeySignInOptionsResponses, BackofficeAuthGeneratePasskeyStepUpOptionsData, BackofficeAuthGeneratePasskeyStepUpOptionsErrors, BackofficeAuthGeneratePasskeyStepUpOptionsResponses, BackofficeAuthGetMeData, BackofficeAuthGetMeErrors, BackofficeAuthGetMeResponses, BackofficeAuthGetSessionData, BackofficeAuthGetSessionErrors, BackofficeAuthGetSessionResponses, BackofficeAuthGetSocialProvidersData, BackofficeAuthGetSocialProvidersErrors, BackofficeAuthGetSocialProvidersResponses, BackofficeAuthIssueSocialNativeNonceData, BackofficeAuthIssueSocialNativeNonceErrors, BackofficeAuthIssueSocialNativeNonceResponses, BackofficeAuthListAdminsData, BackofficeAuthListAdminsErrors, BackofficeAuthListAdminsResponses, BackofficeAuthListPasskeysData, BackofficeAuthListPasskeysErrors, BackofficeAuthListPasskeysResponses, BackofficeAuthListSessionsData, BackofficeAuthListSessionsErrors, BackofficeAuthListSessionsResponses, BackofficeAuthListSocialAccountsData, BackofficeAuthListSocialAccountsErrors, BackofficeAuthListSocialAccountsResponses, BackofficeAuthListTotpAuthenticatorsData, BackofficeAuthListTotpAuthenticatorsErrors, BackofficeAuthListTotpAuthenticatorsResponses, BackofficeAuthRegisterTotpAuthenticatorData, BackofficeAuthRegisterTotpAuthenticatorErrors, BackofficeAuthRegisterTotpAuthenticatorResponses, BackofficeAuthRequestEmailChangeData, BackofficeAuthRequestEmailChangeErrors, BackofficeAuthRequestEmailChangeResponses, BackofficeAuthRequestPasswordResetData, BackofficeAuthRequestPasswordResetErrors, BackofficeAuthRequestPasswordResetResponses, BackofficeAuthResendInviteData, BackofficeAuthResendInviteErrors, BackofficeAuthResendInviteResponses, BackofficeAuthResetPasswordData, BackofficeAuthResetPasswordErrors, BackofficeAuthResetPasswordResponses, BackofficeAuthRevokeSessionData, BackofficeAuthRevokeSessionErrors, BackofficeAuthRevokeSessionResponses, BackofficeAuthSendChangePasswordOtpData, BackofficeAuthSendChangePasswordOtpErrors, BackofficeAuthSendChangePasswordOtpResponses, BackofficeAuthSendDisableTwoFactorOtpData, BackofficeAuthSendDisableTwoFactorOtpErrors, BackofficeAuthSendDisableTwoFactorOtpResponses, BackofficeAuthSendSignInOtpData, BackofficeAuthSendSignInOtpErrors, BackofficeAuthSendSignInOtpResponses, BackofficeAuthSendTwoFactorOtpData, BackofficeAuthSendTwoFactorOtpErrors, BackofficeAuthSendTwoFactorOtpResponses, BackofficeAuthSignInWithAppleData, BackofficeAuthSignInWithAppleErrors, BackofficeAuthSignInWithAppleMobileOttData, BackofficeAuthSignInWithAppleMobileOttErrors, BackofficeAuthSignInWithAppleMobileOttResponses, BackofficeAuthSignInWithAppleResponses, BackofficeAuthSignInWithEmailData, BackofficeAuthSignInWithEmailErrors, BackofficeAuthSignInWithEmailOtpData, BackofficeAuthSignInWithEmailOtpErrors, BackofficeAuthSignInWithEmailOtpResponses, BackofficeAuthSignInWithEmailResponses, BackofficeAuthSignInWithGoogleData, BackofficeAuthSignInWithGoogleErrors, BackofficeAuthSignInWithGoogleResponses, BackofficeAuthSignInWithPasskeyData, BackofficeAuthSignInWithPasskeyErrors, BackofficeAuthSignInWithPasskeyResponses, BackofficeAuthSignOutData, BackofficeAuthSignOutErrors, BackofficeAuthSignOutResponses, BackofficeAuthStartAppleSignInRedirectData, BackofficeAuthStartAppleSignInRedirectErrors, BackofficeAuthStartAppleSignInRedirectResponses, BackofficeAuthStartGoogleSignInRedirectData, BackofficeAuthStartGoogleSignInRedirectErrors, BackofficeAuthStartGoogleSignInRedirectResponses, BackofficeAuthUnlinkSocialAccountData, BackofficeAuthUnlinkSocialAccountErrors, BackofficeAuthUnlinkSocialAccountResponses, BackofficeAuthUpdateAdminAbilitiesData, BackofficeAuthUpdateAdminAbilitiesErrors, BackofficeAuthUpdateAdminAbilitiesResponses, BackofficeAuthUpdateMeData, BackofficeAuthUpdateMeErrors, BackofficeAuthUpdateMePreferencesData, BackofficeAuthUpdateMePreferencesErrors, BackofficeAuthUpdateMePreferencesResponses, BackofficeAuthUpdateMeResponses, BackofficeAuthUpdatePasskeyData, BackofficeAuthUpdatePasskeyErrors, BackofficeAuthUpdatePasskeyResponses, BackofficeAuthUpdateTotpAuthenticatorData, BackofficeAuthUpdateTotpAuthenticatorErrors, BackofficeAuthUpdateTotpAuthenticatorResponses, BackofficeAuthVerifyBackupCodeData, BackofficeAuthVerifyBackupCodeErrors, BackofficeAuthVerifyBackupCodeResponses, BackofficeAuthVerifyPasskeyRegistrationData, BackofficeAuthVerifyPasskeyRegistrationErrors, BackofficeAuthVerifyPasskeyRegistrationResponses, BackofficeAuthVerifyTotpData, BackofficeAuthVerifyTotpEnrollmentData, BackofficeAuthVerifyTotpEnrollmentErrors, BackofficeAuthVerifyTotpEnrollmentResponses, BackofficeAuthVerifyTotpErrors, BackofficeAuthVerifyTotpResponses, BackofficeAuthVerifyTwoFactorOtpData, BackofficeAuthVerifyTwoFactorOtpErrors, BackofficeAuthVerifyTwoFactorOtpResponses, BackofficeAuthVerifyTwoFactorPasskeyData, BackofficeAuthVerifyTwoFactorPasskeyErrors, BackofficeAuthVerifyTwoFactorPasskeyResponses, DocsSchemaData, DocsSchemaErrors, HealthCheckData, HealthCheckErrors, HealthCheckResponses, HealthCheckServicesData, HealthCheckServicesErrors, PoAcceptProposalData, PoAcceptProposalErrors, PoAcceptProposalResponses, PoBulkAcceptProposalsData, PoBulkAcceptProposalsErrors, PoBulkAcceptProposalsResponses, PoCorrectProposalData, PoCorrectProposalErrors, PoCorrectProposalResponses, PoCreateExportData, PoCreateExportErrors, PoCreateExportResponses, PoCreateRunData, PoCreateRunErrors, PoCreateRunResponses, PoGetConfigData, PoGetConfigErrors, PoGetConfigResponses, PoGetExportDownloadData, PoGetExportDownloadErrors, PoGetExportDownloadResponses, PoGetProposalHistoryData, PoGetProposalHistoryErrors, PoGetProposalHistoryResponses, PoGetProposalsData, PoGetProposalsErrors, PoGetProposalsResponses, PoGetRunsData, PoGetRunsErrors, PoGetRunsResponses, PoGetSystemStatusData, PoGetSystemStatusErrors, PoGetSystemStatusResponses, PoListDistributorsData, PoListDistributorsErrors, PoListDistributorsResponses, PoListExportsData, PoListExportsErrors, PoListExportsResponses, PoListProposalsData, PoListProposalsErrors, PoListProposalsResponses, PoListPublishersData, PoListPublishersErrors, PoListPublishersResponses, PoListRunsData, PoListRunsErrors, PoListRunsResponses, PoRefreshDataData, PoRefreshDataErrors, PoRefreshDataResponses, PoRenameRunData, PoRenameRunErrors, PoRenameRunResponses, PoUpdateConfigData, PoUpdateConfigErrors, PoUpdateConfigResponses, PoUpdateRunStatusData, PoUpdateRunStatusErrors, PoUpdateRunStatusResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Schema
 *
 * Returns the OpenAPI JSON schema
 */
export const docsSchema = <ThrowOnError extends boolean = true>(options?: Options<DocsSchemaData, ThrowOnError>) => (options?.client ?? client).get<unknown, DocsSchemaErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/docs/schema',
    ...options
});

/**
 * Heartbeat
 *
 * Agent liveness ping and command channel. Called frequently (every ~10 minutes) so operator actions like “refresh data now” and agent updates stay reactive. Authenticated by the per-agent token in the `X-Agent-Token` header. Returns any queued `commands` to execute now; report their outcome via `acknowledgements` on a later call.
 */
export const agentHeartbeat = <ThrowOnError extends boolean = true>(options: Options<AgentHeartbeatData, ThrowOnError>) => (options.client ?? client).post<AgentHeartbeatResponses, AgentHeartbeatErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/agent/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Manifest
 *
 * Closes a sync round and records the outcome of every table the agent is configured to sync: `stored`, `already_present`, `unchanged` (confirmed at `sha256`) or `failed` (with a `reason`). Send it after uploading the round's tables with the same round id; a round with no uploads is closed too. A round in which a table the documents need (libri, movim, editore, distrib) failed, or that does not list it (recorded as `failed`), closes anyway but is not a complete round, and does not move the agent's last complete sync time. Documents read the tables as of the last complete round: what a round stores enters them only once this call closes it. Idempotent: resending the manifest of a closed round keeps its first close and its first outcomes. A manifest without `tables` (agent 1.0) is refused with `validation_error`. Authenticated by the `X-Agent-Token` header. `commands` is always empty: queued commands are delivered on `heartbeat`.
 */
export const agentManifest = <ThrowOnError extends boolean = true>(options: Options<AgentManifestData, ThrowOnError>) => (options.client ?? client).post<AgentManifestResponses, AgentManifestErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/agent/manifest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Backup
 *
 * Receives one Mr.Book table (a gzipped DBF plus, when present, its gzipped FPT memo file) with its metadata. Idempotent by content hash for stored content: re-sending a table already stored stores nothing new (`already_present`), also when two uploads of it race. Every upload opens its round (by `clientRoundId`) or marks it active: the round is a sync in progress until its manifest closes it. The table is validated on arrival — an unreadable archive, a content hash that does not match `sha256`, or a bad header, size or record-count is `rejected` with a reason and NOT ingested, so the agent resends; a rejected content is validated again on every resend. When the server has lost the stored archive of a content (after a restore of its database), the bytes of the upload restore it and the answer is still `already_present`. A field that cannot be read — `recordCount` or `byteSize` not a non-negative integer, `sha256` not 64 lowercase hex characters, `mtime` not an ISO-8601 instant with its offset, an over-long `tableName` or `clientRoundId` — is `malformed_backup_upload` and nothing is stored. Authenticated by the `X-Agent-Token` header. `commands` is always empty: queued commands are delivered on `heartbeat`.
 */
export const agentBackup = <ThrowOnError extends boolean = true>(options?: Options<AgentBackupData, ThrowOnError>) => (options?.client ?? client).post<AgentBackupResponses, AgentBackupErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/agent/backup',
    ...options
});

/**
 * Get Status
 *
 * Return the current app configuration and a computed `status` telling the client whether it can proceed (`ok`), must update (`force_update`), or the app is under maintenance (`maintenance`). Public — no authentication required. Send the client platform and version headers so the version check applies; when omitted the check is skipped and only maintenance mode affects the status. `maintenance` details are present only while maintenance mode is active. Poll this to detect required updates or downtime.
 */
export const appConfigGetStatus = <ThrowOnError extends boolean = true>(options?: Options<AppConfigGetStatusData, ThrowOnError>) => (options?.client ?? client).post<AppConfigGetStatusResponses, AppConfigGetStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/app-config/get-status',
    ...options
});

/**
 * Sign In With Email
 *
 * Signs an existing back-office admin in with `email` and `password`. Public; no authentication required. Never creates an account — admins are invite-only. On success the response carries the new session (token, `csrfToken`, expiry), the admin, and the abilities granted to them; browsers also receive the session as a cookie. To avoid leaking which addresses are registered, an unknown email, a wrong password, and an admin with no password all return the same error. A disabled admin is rejected after the password is verified. Rate-limited per client address and per account (only failed attempts count against the account): past either limit you receive 429 `backoffice_rate_limited` with `retryAfterSeconds`.
 */
export const backofficeAuthSignInWithEmail = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSignInWithEmailData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSignInWithEmailResponses, BackofficeAuthSignInWithEmailErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/sign-in-with-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Sign In Otp
 *
 * Starts a passwordless sign-in: emails a one-time code to `email` when it belongs to an active admin, and returns a short-lived `emailOtpToken` to resend alongside the code at `sign-in-with-email-otp`. Public and invite-only — a code is sent only to a known admin, but the response is identical whether or not the address exists, so it can't be used to enumerate admins. Returns 429 with `retryAfterSeconds` when a code was issued for this address less than a minute ago. Requests from one client address are also rate-limited (429 `backoffice_rate_limited`).
 */
export const backofficeAuthSendSignInOtp = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSendSignInOtpData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSendSignInOtpResponses, BackofficeAuthSendSignInOtpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/send-sign-in-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Email Otp
 *
 * Completes a passwordless sign-in with the `otp` from the email plus the `emailOtpToken` from `send-sign-in-otp`. Public; never creates an account — admins are invite-only, so a code for an unknown address can never be redeemed. On success the response carries the session, the admin, and the granted abilities; browsers also receive the session cookie. Rate-limited per client address: past the limit you receive 429 `backoffice_rate_limited` with `retryAfterSeconds`.
 */
export const backofficeAuthSignInWithEmailOtp = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSignInWithEmailOtpData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSignInWithEmailOtpResponses, BackofficeAuthSignInWithEmailOtpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/sign-in-with-email-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Password Reset
 *
 * Starts an admin password reset. With `type: magic-link` a reset link is emailed; with `type: otp` a code is emailed and an `emailOtpToken` companion is returned. Public and enumeration-safe: the response is identical whether or not the address belongs to an admin, and nothing is emailed for an unknown address. Returns 429 with `retryAfterSeconds` when a reset was requested for this address less than a minute ago. Requests from one client address are also rate-limited (429 `backoffice_rate_limited`).
 */
export const backofficeAuthRequestPasswordReset = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthRequestPasswordResetData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthRequestPasswordResetResponses, BackofficeAuthRequestPasswordResetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/request-password-reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Password
 *
 * Completes an admin password reset with the token (`type: magic-link`) or the code plus `emailOtpToken` (`type: otp`) from `request-password-reset`, sets `newPassword`, and signs the admin straight in — the response carries the new session, admin, and abilities. The `otp` branch requires `emailOtpToken`: a missing/expired/mismatched one is rejected with 401 without burning the code, so a legitimate retry with the right token still succeeds; after five wrong attempts against the same code the code is revoked and a new one must be requested. The proof is single-use and cannot be replayed across methods (an OTP code is not accepted as a magic-link token, and vice-versa). `revokeOtherSessions` (default true) ends every other active session first. When two-factor is enabled the password is still rotated and other sessions still revoked, but the response is `status: requires_mfa` and no session is issued until a second factor clears. Public. Rate-limited per client address: past the limit you receive 429 `backoffice_rate_limited` with `retryAfterSeconds`.
 */
export const backofficeAuthResetPassword = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthResetPasswordData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthResetPasswordResponses, BackofficeAuthResetPasswordErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Password
 *
 * Rotates the authenticated admin's password to `newPassword` after authorizing the change with one of three methods, discriminated by `type`, in a fixed priority: when two-factor is enabled the only accepted method is `type: "totp"` (a `deviceId` + authenticator `code`); otherwise, when a password is set, `type: "current-password"` re-confirms it; otherwise (passwordless admin with a verified email) `type: "otp"` after requesting a code via `send-change-password-otp`. A `type` that does not match the admin's current channel is rejected. By default other sessions are ended once the change succeeds; pass `revokeOtherSessions: false` to keep them. The current session is preserved, so no new token is issued. A passwordless admin with no verified email is rejected with `backoffice_no_change_password_method_available`.
 */
export const backofficeAuthChangePassword = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthChangePasswordData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthChangePasswordResponses, BackofficeAuthChangePasswordErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Change Password Otp
 *
 * Emails a single-use, time-limited code to the authenticated admin's verified email that authorizes a password change from inside an active session. The code is delivered to the address on file (none is taken from the request), valid for 5 minutes, single-use, and bound to the calling admin — submit it to `change-password` with `type: "otp"`. The response also carries the signed `emailOtpToken` companion the admin must echo back at `change-password` together with the typed code — without it the code is not redeemable. Requesting a new code invalidates any earlier one (and the matching `emailOtpToken` must come from the same call). Returns 400 when the admin has no verified email, and 429 with `retryAfterSeconds` when a code was issued less than a minute ago.
 */
export const backofficeAuthSendChangePasswordOtp = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSendChangePasswordOtpData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSendChangePasswordOtpResponses, BackofficeAuthSendChangePasswordOtpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/send-change-password-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Social Providers
 *
 * Returns the social-login providers ready for back-office sign-in, each with the public client configuration the frontend needs (provider identifier, public OAuth client ID, requested scopes). Public. A provider appears only when fully configured on the server, so the list reflects exactly which sign-in options to show. Back-office supports Google and Apple (authenticate-only).
 */
export const backofficeAuthGetSocialProviders = <ThrowOnError extends boolean = true>(options?: Options<BackofficeAuthGetSocialProvidersData, ThrowOnError>) => (options?.client ?? client).post<BackofficeAuthGetSocialProvidersResponses, BackofficeAuthGetSocialProvidersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/get-social-providers',
    ...options
});

/**
 * Issue Social Native Nonce
 *
 * Issues a single-use, short-lived nonce for native social sign-in (Google / Apple). Public. Embed the `nonce` in the provider's on-device sign-in; the provider echoes it in the id_token, which `sign-in-with-google` / `sign-in-with-apple` verifies and consumes (anti-replay). Request a fresh nonce per attempt.
 */
export const backofficeAuthIssueSocialNativeNonce = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthIssueSocialNativeNonceData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthIssueSocialNativeNonceResponses, BackofficeAuthIssueSocialNativeNonceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/issue-social-native-nonce',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Google
 *
 * Signs a back-office admin in with Google. Public, authenticate-only — never creates an account. Pass an authorization `code` from the web popup (`type: code`) or a native `token` id_token carrying a prior `issue-social-native-nonce` nonce (`type: token`). The Google identity must already belong to an active admin, or its verified email must match an invited admin (linked on this first sign-in); otherwise the call is rejected. On success the response carries the session, admin, and abilities.
 */
export const backofficeAuthSignInWithGoogle = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSignInWithGoogleData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSignInWithGoogleResponses, BackofficeAuthSignInWithGoogleErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/sign-in-with-google',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Apple
 *
 * Signs a back-office admin in with Apple using a native id_token that carries a prior `issue-social-native-nonce` nonce. Public, authenticate-only — never creates an account. The Apple identity must already belong to an active admin, or its verified email must match an invited admin (linked on this first sign-in); otherwise the call is rejected. On success the response carries the session, admin, and abilities.
 */
export const backofficeAuthSignInWithApple = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSignInWithAppleData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSignInWithAppleResponses, BackofficeAuthSignInWithAppleErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/sign-in-with-apple',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Apple Mobile Ott
 *
 * Completes a native back-office Apple sign-in via the one-time token (OTT) handed back through the device deep link. Public — the OTT is the proof. Submit the `ott` and the original `state`. Single-use and short-lived; reused/mismatched/stale values are rejected. On success the response carries the session, admin, and abilities.
 */
export const backofficeAuthSignInWithAppleMobileOtt = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSignInWithAppleMobileOttData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSignInWithAppleMobileOttResponses, BackofficeAuthSignInWithAppleMobileOttErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/sign-in-with-apple-mobile-ott',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Google Sign In Redirect
 *
 * Begins a back-office Google sign-in via browser redirect and returns the provider `url` to send the admin to. Pass the relative `callback`/`errorCallback` paths on the back-office frontend. Authenticate-only — the callback signs in an existing admin and never creates an account.
 */
export const backofficeAuthStartGoogleSignInRedirect = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthStartGoogleSignInRedirectData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthStartGoogleSignInRedirectResponses, BackofficeAuthStartGoogleSignInRedirectErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/start-google-sign-in-redirect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Apple Sign In Redirect
 *
 * Begins a back-office Apple sign-in via browser redirect and returns the provider `url` to send the admin to. Pass the relative `callback`/`errorCallback` paths on the back-office frontend. Authenticate-only — the callback signs in an existing admin and never creates an account. Apple returns to the callback via `form_post`.
 */
export const backofficeAuthStartAppleSignInRedirect = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthStartAppleSignInRedirectData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthStartAppleSignInRedirectResponses, BackofficeAuthStartAppleSignInRedirectErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/start-apple-sign-in-redirect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Social Accounts
 *
 * Lists the social accounts linked to the authenticated admin, oldest first. Authenticated admins only.
 */
export const backofficeAuthListSocialAccounts = <ThrowOnError extends boolean = true>(options?: Options<BackofficeAuthListSocialAccountsData, ThrowOnError>) => (options?.client ?? client).post<BackofficeAuthListSocialAccountsResponses, BackofficeAuthListSocialAccountsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-social-accounts',
    ...options
});

/**
 * Unlink Social Account
 *
 * Removes the authenticated admin's link to the given social `provider`. Authenticated admins only. Idempotent — succeeds even when no such link exists. The admin can always still sign in with their password or via a reset, so no last-method guard applies.
 */
export const backofficeAuthUnlinkSocialAccount = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthUnlinkSocialAccountData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthUnlinkSocialAccountResponses, BackofficeAuthUnlinkSocialAccountErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/unlink-social-account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Admin
 *
 * Invites a new back-office admin: creates the account (no password yet) with the given `abilities` and emails an invite link to set a password via `accept-invite`. Requires the `admins.manage` ability. Returns the created admin. Rejects a duplicate email with 409.
 */
export const backofficeAuthCreateAdmin = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthCreateAdminData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthCreateAdminResponses, BackofficeAuthCreateAdminErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/create-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Invite
 *
 * Accepts an admin invite: sets the admin's `password` (and optional `name`), confirms the email, and signs them straight in — the response carries the session, admin, and abilities. Public; the invite `token` is the proof. A consumed, expired, or unknown token is rejected. Rate-limited per client address: past the limit you receive 429 `backoffice_rate_limited` with `retryAfterSeconds`.
 */
export const backofficeAuthAcceptInvite = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthAcceptInviteData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthAcceptInviteResponses, BackofficeAuthAcceptInviteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/accept-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Invite
 *
 * Re-sends the invite email to a pending admin (one who has not yet accepted). Requires the `admins.manage` ability. Rejects with 400 when the admin has already accepted (use the password reset flow instead) and 404 when no such admin exists.
 */
export const backofficeAuthResendInvite = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthResendInviteData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthResendInviteResponses, BackofficeAuthResendInviteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/resend-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Admins
 *
 * List back-office admins, one page at a time. Requires the `admins.manage` ability. Narrow results with `filters` (an explicit `ids` list to fetch a known set or a single admin, free-text `search` over name and email that also matches a full admin id pasted in, an `abilities` set matched as any-of, a `disabled` state, and a derived lifecycle `status`) and order them with `sort`. Read `meta` for the total count and total page count, and request successive `page` values to page through the result. Deleted admins are never returned.
 */
export const backofficeAuthListAdmins = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthListAdminsData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthListAdminsResponses, BackofficeAuthListAdminsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Admins
 *
 * Export back-office admins using the same filters and sort supported by `list-admins`. Small exports can be downloaded synchronously; large exports are queued.
 */
export const backofficeAuthExportAdmins = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthExportAdminsData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthExportAdminsResponses, BackofficeAuthExportAdminsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/export-admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exports :id
 *
 * Return the status of an async export requested by the signed-in admin. Completed exports include a short-lived download URL.
 */
export const backofficeAuthExportsId = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthExportsIdData, ThrowOnError>) => (options.client ?? client).get<BackofficeAuthExportsIdResponses, BackofficeAuthExportsIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/exports/{id}',
    ...options
});

/**
 * Update Admin Abilities
 *
 * Replace an admin's abilities with exactly the given set (any ability not listed is revoked). Requires the `admins.manage` ability. You cannot change your own abilities. Returns the updated admin.
 */
export const backofficeAuthUpdateAdminAbilities = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthUpdateAdminAbilitiesData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthUpdateAdminAbilitiesResponses, BackofficeAuthUpdateAdminAbilitiesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-admin-abilities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disable Admin
 *
 * Disable an admin: blocks all sign-in and immediately ends every active session. Requires the `admins.manage` ability. You cannot disable your own account. Idempotent — disabling an already-disabled admin keeps the original disabled time. Returns the updated admin; re-enable with `enable-admin`.
 */
export const backofficeAuthDisableAdmin = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthDisableAdminData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthDisableAdminResponses, BackofficeAuthDisableAdminErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/disable-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable Admin
 *
 * Re-enable a disabled admin so they can sign in again. Requires the `admins.manage` ability. Idempotent — enabling an already-active admin is a no-op. Returns the updated admin. Existing sessions stay revoked; the admin signs in afresh.
 */
export const backofficeAuthEnableAdmin = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthEnableAdminData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthEnableAdminResponses, BackofficeAuthEnableAdminErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/enable-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Admin
 *
 * Delete the admins in `ids` and return no content. Requires the `admins.manage` ability. Deleting an admin ends all their sessions and frees their email for re-invitation. You cannot delete your own account. All-or-nothing: if any id is unknown (or already deleted) nothing is deleted and the request is rejected.
 */
export const backofficeAuthDeleteAdmin = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthDeleteAdminData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthDeleteAdminResponses, BackofficeAuthDeleteAdminErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/delete-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register Totp Authenticator
 *
 * Register a new TOTP authenticator for the authenticated admin and return the setup URI plus a manual-entry secret. Render `totpURI` as a QR code, or let the admin type `secret` by hand, then confirm the first generated code via `verify-totp-enrollment` to finish enrolling. There is a cap on devices per admin; enrolling beyond it returns 409.
 */
export const backofficeAuthRegisterTotpAuthenticator = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthRegisterTotpAuthenticatorData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthRegisterTotpAuthenticatorResponses, BackofficeAuthRegisterTotpAuthenticatorErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/register-totp-authenticator',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Totp Enrollment
 *
 * Confirm a just-registered authenticator by submitting the first `code` it shows for `deviceId` from `register-totp-authenticator`. On success the device is activated and two-factor authentication is enabled on the account. Returns 400 when the code is wrong or the short enrollment window has expired — restart enrollment via `register-totp-authenticator`. The submitted `code` is single-use; retrying for an already-confirmed device with the same in-window code still resolves successfully.
 */
export const backofficeAuthVerifyTotpEnrollment = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthVerifyTotpEnrollmentData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthVerifyTotpEnrollmentResponses, BackofficeAuthVerifyTotpEnrollmentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/verify-totp-enrollment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Totp
 *
 * Verifies an authenticator `code` for the chosen `deviceId` during a sign-in MFA challenge and, on success, issues the session. Public; the challenge is identified by the `mfaToken` in the body. On a wrong code you may retry with the same challenge until it is revoked after too many failed attempts, after which you must sign in again. Rate-limited per client address: past the limit you receive 429 `backoffice_rate_limited` with `retryAfterSeconds`.
 */
export const backofficeAuthVerifyTotp = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthVerifyTotpData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthVerifyTotpResponses, BackofficeAuthVerifyTotpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/verify-totp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Backup Code
 *
 * Verifies a one-time backup `code` during a sign-in MFA challenge — the break-glass fallback when you cannot use your authenticator — and, on success, issues the session. Public; the challenge is identified by the `mfaToken` in the body. A wrong code may be retried with the same challenge until it is revoked after too many failed attempts. Each valid backup code works only once. Rate-limited per client address: past the limit you receive 429 `backoffice_rate_limited` with `retryAfterSeconds`.
 */
export const backofficeAuthVerifyBackupCode = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthVerifyBackupCodeData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthVerifyBackupCodeResponses, BackofficeAuthVerifyBackupCodeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/verify-backup-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Backup Codes
 *
 * Generate a fresh batch of single-use backup codes for the authenticated admin, invalidating any previously-issued unused codes. Admins only. Two-factor must already be active — enroll an authenticator via `register-totp-authenticator` + `verify-totp-enrollment` first, otherwise the call is rejected. The codes are returned in cleartext exactly once and cannot be retrieved later — present them immediately so the admin can store them. Use a code at `verify-backup-code` during a sign-in challenge.
 */
export const backofficeAuthGenerateBackupCodes = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthGenerateBackupCodesData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthGenerateBackupCodesResponses, BackofficeAuthGenerateBackupCodesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/generate-backup-codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Totp Authenticators
 *
 * List the authenticated admin's own confirmed TOTP authenticators, one page at a time and ordered by most recent use, each with its friendly `name`, `verifiedAt`, and `lastUsedAt`. Never exposes another admin's devices, in-flight (unconfirmed) enrollments, or removed devices. Drives the rename (`update-totp-authenticator`) and removal (`delete-totp-authenticator`) actions.
 */
export const backofficeAuthListTotpAuthenticators = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthListTotpAuthenticatorsData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthListTotpAuthenticatorsResponses, BackofficeAuthListTotpAuthenticatorsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-totp-authenticators',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Totp Authenticator
 *
 * Rename one of the authenticated admin's own confirmed TOTP authenticators. You can only update an authenticator you own that has already been confirmed via `verify-totp-enrollment`. Pass the device `id` and the new `name` — the response echoes the device in its updated form. Removing an authenticator is done via `delete-totp-authenticator`.
 */
export const backofficeAuthUpdateTotpAuthenticator = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthUpdateTotpAuthenticatorData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthUpdateTotpAuthenticatorResponses, BackofficeAuthUpdateTotpAuthenticatorErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-totp-authenticator',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Totp Authenticator
 *
 * Remove one of the authenticated admin's own TOTP authenticators, identified by `id`. Idempotent and always succeeds: removing a device that does not exist, is not yours, or is already removed returns success with no effect, so callers cannot probe which device ids exist. Removing the last verified device does not automatically turn off two-factor for the account — use `disable-two-factor` to do so explicitly.
 */
export const backofficeAuthDeleteTotpAuthenticator = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthDeleteTotpAuthenticatorData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthDeleteTotpAuthenticatorResponses, BackofficeAuthDeleteTotpAuthenticatorErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/delete-totp-authenticator',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable Two Factor
 *
 * Turn on two-factor authentication on the authenticated admin's account. Idempotent: calling on an already-enabled account succeeds with no effect. Raising this flag alone does not force a challenge at sign-in — the admin must also have at least one verified authenticator (enroll one via `register-totp-authenticator` + `verify-totp-enrollment`).
 */
export const backofficeAuthEnableTwoFactor = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthEnableTwoFactorData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthEnableTwoFactorResponses, BackofficeAuthEnableTwoFactorErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/enable-two-factor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disable Two Factor
 *
 * Turn off two-factor authentication on the authenticated admin's account so future sign-ins no longer require a second factor. Authenticated admins only. Requires a second-factor step-up so a stolen session alone cannot disable MFA: pick a method via the discriminated `type` field. TOTP and passkey are the primary channels — either is accepted whenever the corresponding factor is enrolled. Recovery codes are accepted as single-use break-glass credentials from an authenticated session. Email OTP is the fallback and is only accepted when the account has neither a TOTP authenticator nor a passkey enrolled, and has a verified email on file; in that case obtain the code first via `send-disable-two-factor-otp`. A `type` that does not match the account's enrolled factors is rejected with `backoffice_disable_two_factor_method_not_available`. An account with none of (TOTP, passkey, verified email) needs no step-up — submit any supported `type` carrying a placeholder credential and the call still succeeds, since no second factor exists to challenge. Idempotent: calling on an already-disabled account still succeeds with no effect. Registered TOTP authenticators and recovery codes that were not used for this step-up are preserved, so the admin can re-enable later via `enable-two-factor` without re-enrolling.
 */
export const backofficeAuthDisableTwoFactor = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthDisableTwoFactorData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthDisableTwoFactorResponses, BackofficeAuthDisableTwoFactorErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/disable-two-factor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Disable Two Factor Otp
 *
 * Emails a single-use, time-limited code to the authenticated admin's verified email address that authorizes disabling two-factor authentication from inside an active session. Authenticated admins only; the code is delivered to whatever address the account currently has on file, so no recipient is taken from the request. The code is 8 characters long, valid for 5 minutes, single-use, and bound to the calling account — pair it with `disable-two-factor` by submitting `type: "email-otp"` and the received code. The email-OTP channel is the fallback second factor reserved for accounts that have neither a TOTP authenticator nor a passkey enrolled; if you have either, this endpoint returns `backoffice_disable_two_factor_otp_unavailable` (400) and you must clear the step-up via `disable-two-factor` with `type: "totp"` or `type: "passkey"` instead. The same error is returned when the account has no verified email to deliver the code to. Requesting a new code invalidates any earlier code still outstanding for the same account. Returns 429 with `retryAfterSeconds` when another code was issued for this address less than a minute ago.
 */
export const backofficeAuthSendDisableTwoFactorOtp = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSendDisableTwoFactorOtpData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSendDisableTwoFactorOtpResponses, BackofficeAuthSendDisableTwoFactorOtpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/send-disable-two-factor-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Passkey Register Options
 *
 * Returns the WebAuthn options the authenticator needs to create a new passkey for the signed-in admin, together with a short-lived `passkeyToken`. Authenticated admins only — this enrolls an additional passkey, it does not sign anyone in. The challenge is valid for a few minutes and is single-use: pass the resulting `passkeyToken` and the authenticator's response to `verify-passkey-registration` to finish enrollment. The authenticator is told about existing passkeys for this account so it refuses to enroll one already in use. Optionally constrain the authenticator type via `authenticatorAttachment`. Rejected with 409 when the account has reached the maximum number of registered passkeys — remove an existing passkey before enrolling a new one.
 */
export const backofficeAuthGeneratePasskeyRegisterOptions = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthGeneratePasskeyRegisterOptionsData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthGeneratePasskeyRegisterOptionsResponses, BackofficeAuthGeneratePasskeyRegisterOptionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/generate-passkey-register-options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Passkey Registration
 *
 * Verifies the authenticator's response and registers the passkey on the signed-in admin's account. Authenticated admins only — this completes enrollment, it does not sign anyone in. Send the `response` produced by the authenticator together with the `passkeyToken` from `generate-passkey-register-options`; on success the new passkey becomes usable for passkey sign-in. Rejected with 409 when the account has reached the maximum number of registered passkeys — remove an existing passkey before enrolling a new one.
 */
export const backofficeAuthVerifyPasskeyRegistration = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthVerifyPasskeyRegistrationData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthVerifyPasskeyRegistrationResponses, BackofficeAuthVerifyPasskeyRegistrationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/verify-passkey-registration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Passkeys
 *
 * List the authenticated admin's own passkeys, one page at a time and ordered by most recent use, each with its friendly `name`, device details, and `lastUsedAt`. Authenticated admins only; never exposes another admin's passkeys. Drives the rename (`update-passkey`) and removal (`delete-passkey`) actions.
 */
export const backofficeAuthListPasskeys = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthListPasskeysData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthListPasskeysResponses, BackofficeAuthListPasskeysErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-passkeys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Passkey
 *
 * Rename one of the authenticated admin's own passkeys. Authenticated admins only; you can only update a passkey you own. Pass the passkey `id` and the new `name` — the response echoes the passkey in its updated form. Use this to label multiple passkeys (e.g. 'MacBook Touch ID', 'YubiKey'). Removing a passkey is done via `delete-passkey`.
 */
export const backofficeAuthUpdatePasskey = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthUpdatePasskeyData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthUpdatePasskeyResponses, BackofficeAuthUpdatePasskeyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Passkey
 *
 * Remove one of the authenticated admin's own passkeys, identified by `id`. Authenticated admins only. Idempotent and always succeeds: removing a passkey that does not exist, is not yours, or is already removed returns success with no effect, so callers cannot probe which passkey ids exist. Once removed the passkey can no longer be used to sign in; you can re-enroll the same authenticator later. List the available passkeys with `list-passkeys`.
 */
export const backofficeAuthDeletePasskey = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthDeletePasskeyData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthDeletePasskeyResponses, BackofficeAuthDeletePasskeyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/delete-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Passkey Sign In Options
 *
 * Returns the WebAuthn options the authenticator needs to assert an existing passkey, together with a short-lived `passkeyToken`. Public; no authentication required — this starts a passkey sign-in. The options do not list which credentials exist on the server, so the client surfaces the platform's native credential selector and the server resolves the admin from whichever passkey the authenticator returns. User verification (biometric or PIN) is required for sign-in via passkey, so the assertion the authenticator returns must be user-verified; credentials that cannot perform UV remain usable as a second factor via `generate-passkey-step-up-options`. The challenge is valid for a few minutes and is single-use: pass the resulting `passkeyToken` and the authenticator's response to `sign-in-with-passkey` to finish signing in.
 */
export const backofficeAuthGeneratePasskeySignInOptions = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthGeneratePasskeySignInOptionsData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthGeneratePasskeySignInOptionsResponses, BackofficeAuthGeneratePasskeySignInOptionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/generate-passkey-sign-in-options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Passkey
 *
 * Completes a passkey sign-in by verifying the authenticator's assertion against a previously registered passkey. Public; no authentication required. Pairs with `generate-passkey-sign-in-options`, which mints the WebAuthn challenge and the matching `passkeyToken`. The token is single-use and expires shortly after it is issued, so a reused or stale challenge is rejected. The assertion must be user-verified — the authenticator collected a biometric or PIN — so a passkey signed in here satisfies multi-factor authentication on its own and the session is issued immediately, even when the account has MFA enabled. An assertion that only proved user presence (no verification, e.g. a security key without a PIN) is rejected; those credentials are still usable as a second factor via `verify-two-factor-passkey`. An unknown credential, a bad signature, and a counter rollback (cloned-key detection) all collapse to the same error so the endpoint cannot be used to probe which passkeys exist on the server. On success the response carries the session token and the `csrfToken` to attach to later mutating requests; browsers additionally receive the session as a cookie.
 */
export const backofficeAuthSignInWithPasskey = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSignInWithPasskeyData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSignInWithPasskeyResponses, BackofficeAuthSignInWithPasskeyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/sign-in-with-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Passkey Step Up Options
 *
 * Returns the WebAuthn options the authenticator needs to assert an existing passkey as a second factor, together with a short-lived `passkeyToken`. Public; no authentication required — this is called between a `requires_mfa` response and `verify-two-factor-passkey`. User verification is `preferred` (not `required`) on purpose: as an explicit second factor a passkey only needs to prove possession of a registered credential of the account, so a non-UV authenticator (e.g. a security key without a PIN) is still accepted — matching the semantics of `verify-two-factor-passkey`. The options do not list which credentials exist on the server, so the client surfaces the platform's native credential selector. The challenge is valid for a few minutes and is single-use: pass the resulting `passkeyToken` and the authenticator's response to `verify-two-factor-passkey` to clear the MFA challenge.
 */
export const backofficeAuthGeneratePasskeyStepUpOptions = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthGeneratePasskeyStepUpOptionsData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthGeneratePasskeyStepUpOptionsResponses, BackofficeAuthGeneratePasskeyStepUpOptionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/generate-passkey-step-up-options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Two Factor Passkey
 *
 * Completes a sign-in MFA challenge with a passkey assertion and, on success, issues your session. Public; no authentication required. First call `generate-passkey-step-up-options` to obtain the WebAuthn options, assert the passkey, then send the `response` here. The challenge is identified by the `mfaToken` in the body; the challenge cookie is never read. Any valid passkey assertion belonging to the account that started this sign-in clears the challenge — user verification (biometric / PIN) is NOT required when a passkey is used as a second factor, only possession of a registered credential. A passkey is NOT an available second factor when the first factor was itself a passkey: pairing the two would collapse both factors to a single credential or to mere possession of a registered credential, so the call is rejected — use TOTP or a recovery code instead. An assertion that belongs to a different account is rejected. On rejection you may retry with the same challenge until it is revoked after too many failed attempts, after which you must sign in again.
 */
export const backofficeAuthVerifyTwoFactorPasskey = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthVerifyTwoFactorPasskeyData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthVerifyTwoFactorPasskeyResponses, BackofficeAuthVerifyTwoFactorPasskeyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/verify-two-factor-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Two Factor Otp
 *
 * Emails a one-time code as the second factor for an in-progress sign-in MFA challenge. Public; no authentication required. The challenge is identified by the `mfaToken` in the body; the challenge cookie is never read — an invalid challenge is rejected. Email codes are only offered when you signed in with a password, your account has a verified email, and your account has neither a TOTP authenticator nor a passkey enrolled — email OTP is reserved as a fallback for admins without a stronger factor; if you have a TOTP authenticator or a passkey you must use those instead. After it succeeds, submit the code via `verify-two-factor-otp`. The code expires after a short window, and requesting a new one invalidates any earlier code still outstanding. Returns 429 with `retryAfterSeconds` when another code was requested less than a minute ago. Requests from one client address are also rate-limited (429 `backoffice_rate_limited`).
 */
export const backofficeAuthSendTwoFactorOtp = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSendTwoFactorOtpData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSendTwoFactorOtpResponses, BackofficeAuthSendTwoFactorOtpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/send-two-factor-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Two Factor Otp
 *
 * Verifies the one-time `code` emailed during a sign-in MFA challenge and, on success, issues your session. Public; no authentication required. The challenge is identified by the `mfaToken` in the body; the challenge cookie is never read. Request the code first via `send-two-factor-otp`. Email codes are only accepted as a second factor when you signed in with a password and your account has neither a TOTP authenticator nor a passkey enrolled — email OTP is reserved as a fallback for admins without a stronger factor; if you have a TOTP authenticator or a passkey you must use those instead. For a passwordless, social, or passkey sign-in the call is rejected. On a wrong code you may retry with the same challenge until it is revoked after too many failed attempts, after which you must sign in again. Rate-limited per client address: past the limit you receive 429 `backoffice_rate_limited` with `retryAfterSeconds`.
 */
export const backofficeAuthVerifyTwoFactorOtp = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthVerifyTwoFactorOtpData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthVerifyTwoFactorOtpResponses, BackofficeAuthVerifyTwoFactorOtpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/verify-two-factor-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Sessions
 *
 * List the authenticated admin's own sessions, one page at a time and ordered by most recent activity, each with its approximate location, device details, and lifecycle `status`. Never exposes another admin's sessions. Revoked and expired sessions stay in the list and are surfaced through `status`, while the session the request was made with is flagged by `isCurrent`. Pass `filters.status` to keep only sessions in a given lifecycle state. End any session with `revoke-session`.
 */
export const backofficeAuthListSessions = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthListSessionsData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthListSessionsResponses, BackofficeAuthListSessionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Session
 *
 * Revoke the session identified by `sessionId`, signing out that device. Idempotent and always succeeds: revoking a session that does not exist, is not yours, or is already revoked returns success with no effect, so callers cannot probe which sessions exist. Revoking the session the call was made with immediately signs the caller out. List the available sessions with `list-sessions`.
 */
export const backofficeAuthRevokeSession = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthRevokeSessionData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthRevokeSessionResponses, BackofficeAuthRevokeSessionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/revoke-session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Email Change
 *
 * Start changing the authenticated admin's email to `newEmail` by sending a one-time code to that new address. If the admin already has an email, a second code is also sent to the current address and both are required to confirm. The codes are single-use and expire shortly after they are sent; submit them with `newEmail` and the `emailOtpToken` returned here to `confirm-email-change`. `currentEmailVerificationRequired` is true when a code was also sent to the current address. The response is uniform whether or not `newEmail` already belongs to another admin, so callers cannot enumerate addresses; an ownership clash is only surfaced at `confirm-email-change`. Returns 400 only when `newEmail` matches the current address, and 429 with `retryAfterSeconds` when a code was issued less than a minute ago for either address.
 */
export const backofficeAuthRequestEmailChange = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthRequestEmailChangeData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthRequestEmailChangeResponses, BackofficeAuthRequestEmailChangeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/request-email-change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Email Change
 *
 * Complete an email change for the authenticated admin. Submit `newOtp` (the code sent to `newEmail`) and, when the admin already has an email, also `currentOtp` (the code sent to the current address) — both must match to switch the account to `newEmail` and mark it verified. Also submit `emailOtpToken` from `request-email-change`: it binds the codes to that request, so a stale or missing token is rejected without consuming either code. Codes are single-use and short-lived: a wrong, expired, reused, missing, or mismatched code is rejected with 400 and the change is not applied. Returns 401 when `emailOtpToken` is missing, expired, or does not match the request, and 409 when the address was claimed by another admin after the codes were requested. No new session is issued.
 */
export const backofficeAuthConfirmEmailChange = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthConfirmEmailChangeData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthConfirmEmailChangeResponses, BackofficeAuthConfirmEmailChangeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/confirm-email-change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Me
 *
 * Return the authenticated admin's own profile (id, email, display name, and whether two-factor is enabled) together with the `abilities` granted to them for client-side UI gating. Authenticated admins only; the account is resolved from the session. Use `update-me` to change the editable fields (name).
 */
export const backofficeAuthGetMe = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthGetMeData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthGetMeResponses, BackofficeAuthGetMeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/get-me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Me
 *
 * Update the authenticated admin's own profile and return the updated record. Admins only; the account is resolved from the session. Only `name` can be changed — fields you omit stay as they are. To change interface language or theme use `update-me-preferences`; to change your email use `request-email-change`; to change your password use `change-password`.
 */
export const backofficeAuthUpdateMe = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthUpdateMeData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthUpdateMeResponses, BackofficeAuthUpdateMeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Me Preferences
 *
 * Update the authenticated admin's interface preferences and return the updated values. Admins only; preferences are resolved from the session. Only `language` and `theme` can be changed — fields you omit stay as they are. The chosen `language` is the language of emails sent to this admin.
 */
export const backofficeAuthUpdateMePreferences = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthUpdateMePreferencesData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthUpdateMePreferencesResponses, BackofficeAuthUpdateMePreferencesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-me-preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Session
 *
 * Returns the caller's back-office auth context: `sessionType` is `unauthenticated` when no valid session is present and `authenticated` otherwise, with the `session`, `admin`, and `abilities` blocks populated. The `admin` block is the auth identity only (`id` and whether two-factor is enabled); fetch the full profile (email, name) via `get-me`. Public; works with or without credentials, so it is the endpoint to call on app start or after a reload to recover the signed-in state. When authenticated it also returns a fresh `csrfToken` for later mutating requests.
 */
export const backofficeAuthGetSession = <ThrowOnError extends boolean = true>(options?: Options<BackofficeAuthGetSessionData, ThrowOnError>) => (options?.client ?? client).post<BackofficeAuthGetSessionResponses, BackofficeAuthGetSessionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/get-session',
    ...options
});

/**
 * Sign Out
 *
 * Ends a back-office session and clears the session cookie. Public and idempotent: pass the session's `token` in the body, or rely on the session cookie together with a valid `x-csrf-token` header. When no recognised credentials are present it is a no-op. Always succeeds.
 */
export const backofficeAuthSignOut = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSignOutData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSignOutResponses, BackofficeAuthSignOutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/sign-out',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Runs
 *
 * Elenca i documenti di proposta (l'indice, stile home di fogli di calcolo), per default ordinati per ultima modifica, che comprende le decisioni dell'esperto sulle righe; ordinabili con `sort`. I documenti passati restano sempre qui: l'indice è lo storico delle campagne. Richiede un account autenticato. Filtra per nome con `filters.search`.
 */
export const poListRuns = <ThrowOnError extends boolean = true>(options: Options<PoListRunsData, ThrowOnError>) => (options.client ?? client).post<PoListRunsResponses, PoListRunsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Run
 *
 * Crea un nuovo documento di proposta e avvia la generazione (“Genera proposte”). L'anno di campagna è derivato dal calendario al momento della creazione, senza cerimonia. La generazione è asincrona: il documento nasce `pending` e va monitorato con `get-runs` finché diventa `in_progress` o `failed`. Una sola generazione alla volta: mentre un'altra è in corso risponde `run_already_in_progress`; una generazione interrotta (riavvio, crash) viene chiusa come `failed` entro 17 minuti dal suo avvio. Il documento si genera sui dati dell'ultimo giro di sincronizzazione chiuso e completo dell'agente, anche mentre un aggiornamento dati è in corso: le tabelle di un giro non ancora chiuso non entrano. Senza un giro completo risponde `no_complete_dataset`; se a quel giro manca una tabella indispensabile, `dataset_not_ready`. Se il servizio di elaborazione non è raggiungibile risponde `job_queue_unavailable`: il documento appena creato è già `failed` con il motivo e non blocca una nuova generazione, che si può richiedere più tardi (se la generazione era partita comunque, il documento prosegue normalmente). Richiede un account autenticato.
 */
export const poCreateRun = <ThrowOnError extends boolean = true>(options: Options<PoCreateRunData, ThrowOnError>) => (options.client ?? client).post<PoCreateRunResponses, PoCreateRunErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/create-run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Runs
 *
 * Legge uno o più documenti di proposta per id, con lo stato di generazione, l'avanzamento della revisione e le ripartizioni per editore e distributore. Usalo anche per il polling durante una generazione in corso. Richiede un account autenticato.
 */
export const poGetRuns = <ThrowOnError extends boolean = true>(options: Options<PoGetRunsData, ThrowOnError>) => (options.client ?? client).post<PoGetRunsResponses, PoGetRunsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rename Run
 *
 * Rinomina un documento di proposta (come si rinomina un file). Richiede un account autenticato.
 */
export const poRenameRun = <ThrowOnError extends boolean = true>(options: Options<PoRenameRunData, ThrowOnError>) => (options.client ?? client).post<PoRenameRunResponses, PoRenameRunErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/rename-run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Run Status
 *
 * Fa avanzare un documento nel flusso di lavoro: in lavorazione -> completato -> archiviato; si archivia anche un documento ancora in lavorazione o fallito. Completare richiede che ogni riga sia stata rivista. Entrambe le transizioni sono definitive — un documento completato non si riapre e uno archiviato non si ripristina, se ne genera uno nuovo — quindi falle confermare sempre all'utente. Chiedere lo stato che il documento ha già non cambia nulla; due richieste contemporanee sullo stesso documento vengono servite una dopo l'altra, e la seconda trova lo stato lasciato dalla prima. Richiede un account autenticato.
 */
export const poUpdateRunStatus = <ThrowOnError extends boolean = true>(options: Options<PoUpdateRunStatusData, ThrowOnError>) => (options.client ?? client).post<PoUpdateRunStatusResponses, PoUpdateRunStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/update-run-status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Proposals
 *
 * Elenca le righe di un documento di proposta, una pagina alla volta (la griglia di revisione). L'ordinamento di default è per priorità: righe segnalate in cima. Nessun filtro è attivo di default: ogni titolo dell'universo compare. In ogni riga `details` porta solo la parte del calcolo che la griglia mostra: il calcolo completo si legge con `get-proposals`. La ricerca trova `%`, `_` e `\` alla lettera. Richiede un account autenticato.
 */
export const poListProposals = <ThrowOnError extends boolean = true>(options: Options<PoListProposalsData, ThrowOnError>) => (options.client ?? client).post<PoListProposalsResponses, PoListProposalsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-proposals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Proposals
 *
 * Legge una o più righe di proposta per id, con il dettaglio completo del calcolo (motivazione, disponibilità, segnalazioni) e la memoria delle campagne passate sullo stesso titolo. Richiede un account autenticato.
 */
export const poGetProposals = <ThrowOnError extends boolean = true>(options: Options<PoGetProposalsData, ThrowOnError>) => (options.client ?? client).post<PoGetProposalsResponses, PoGetProposalsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-proposals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Proposal
 *
 * Accetta la quantità proposta per una riga (un click). L'azione è tracciata nella cronologia della riga e reversibile con una successiva correzione. Si accetta solo una riga ancora da rivedere: su una riga già accettata risponde con la riga invariata, su una riga corretta nel frattempo rifiuta con `proposal_already_corrected`. Su un documento non più in lavorazione risponde `run_not_editable`. Richiede un account autenticato.
 */
export const poAcceptProposal = <ThrowOnError extends boolean = true>(options: Options<PoAcceptProposalData, ThrowOnError>) => (options.client ?? client).post<PoAcceptProposalResponses, PoAcceptProposalErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/accept-proposal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Correct Proposal
 *
 * Corregge la quantità di una riga (l'edit inline della cella) e la chiude come `corrected`: correggere è già una decisione, ma lo stato resta distinto da `accepted`. Richiede una `note` obbligatoria che motiva la correzione — è il feedback usato per migliorare l'algoritmo, legato 1:1 alla correzione. La proposta originale non viene mai sovrascritta e ogni modifica resta ricostruibile dalla cronologia. Si corregge solo un documento in lavorazione: altrimenti risponde `run_not_editable`. Una quantità oltre 1.000.000 (per esempio un codice incollato nella cella) è rifiutata come `validation_error`. Richiede un account autenticato.
 */
export const poCorrectProposal = <ThrowOnError extends boolean = true>(options: Options<PoCorrectProposalData, ThrowOnError>) => (options.client ?? client).post<PoCorrectProposalResponses, PoCorrectProposalErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/correct-proposal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Accept Proposals
 *
 * Accetta in blocco, in uno di tre modi. Con `ids` accetta le righe selezionate, qualunque sia la segnalazione (la selezione è una scelta esplicita dell'esperto). Con `filters` («Accetta questa vista») accetta le righe che la vista corrente mostra. Con `all: true` («Accetta tutto») accetta ogni riga ancora da rivedere del documento. In ogni caso le righe già decise (accettate o corrette) non vengono toccate: `accepted` conta solo le righe effettivamente accettate ora. Con `ids`, se un id non è una riga del documento non viene accettata nessuna riga (`proposal_not_found`). Si accetta solo su un documento in lavorazione: altrimenti `run_not_editable`. Richiede un account autenticato.
 */
export const poBulkAcceptProposals = <ThrowOnError extends boolean = true>(options: Options<PoBulkAcceptProposalsData, ThrowOnError>) => (options.client ?? client).post<PoBulkAcceptProposalsResponses, PoBulkAcceptProposalsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/bulk-accept-proposals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Proposal History
 *
 * Cronologia completa di una riga (la cronologia versioni): ogni accettazione, correzione e nota con valore prima/dopo, chi e quando, dalla più vecchia alla più recente. Tre correzioni successive = tre voci: niente va mai perso. Richiede un account autenticato.
 */
export const poGetProposalHistory = <ThrowOnError extends boolean = true>(options: Options<PoGetProposalHistoryData, ThrowOnError>) => (options.client ?? client).post<PoGetProposalHistoryResponses, PoGetProposalHistoryErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-proposal-history',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Distributors
 *
 * Elenca i distributori conosciuti, in ordine alfabetico: le scelte possibili quando si crea un documento limitato ad alcuni distributori. La lista viene dall'ultimo documento generato non ristretto (un documento fallito non conta, anche se archiviato); è vuota finché non ne esiste uno. Richiede un account autenticato.
 */
export const poListDistributors = <ThrowOnError extends boolean = true>(options?: Options<PoListDistributorsData, ThrowOnError>) => (options?.client ?? client).post<PoListDistributorsResponses, PoListDistributorsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-distributors',
    ...options
});

/**
 * List Publishers
 *
 * Elenca le case editrici che trattiamo, dalla più alla meno venduta nella campagna precedente. Serve alla schermata delle esclusive per mostrare anche chi NON è in esclusiva: senza questa lista l'ingrosso si potrebbe solo dedurre da un'assenza. La lista viene dall'ultimo documento generato non ristretto (un documento fallito non conta, anche se archiviato) ed è vuota finché non ne esiste uno. Richiede un account autenticato.
 */
export const poListPublishers = <ThrowOnError extends boolean = true>(options?: Options<PoListPublishersData, ThrowOnError>) => (options?.client ?? client).post<PoListPublishersResponses, PoListPublishersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-publishers',
    ...options
});

/**
 * Create Export
 *
 * Genera l'export degli ordini per un documento: un foglio Excel per editore più un riepilogo complessivo, e un CSV riutilizzabile (codice = ISBN, con la colonna distributore). I filtri del payload rispecchiano quelli della griglia: l'export contiene esattamente le righe che i filtri lasciano passare. L'export fotografa lo stato AL MOMENTO della generazione, correzioni incluse. Si esporta un documento generato (in lavorazione, completato o archiviato dopo la generazione): su un documento ancora in generazione o fallito, anche se poi archiviato, risponde `run_not_generated`. I documenti di simulazione a magazzino vuoto non sono esportabili. La generazione è asincrona: monitora con `list-exports` finché `status` è `completed`, poi scarica con `get-export-download`. Se il servizio di elaborazione non è raggiungibile risponde `job_queue_unavailable`: l'export appena creato è già `failed` con il motivo, e si può rifare più tardi. Ogni export resta per sempre nello storico. Richiede un account autenticato.
 */
export const poCreateExport = <ThrowOnError extends boolean = true>(options: Options<PoCreateExportData, ThrowOnError>) => (options.client ?? client).post<PoCreateExportResponses, PoCreateExportErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/create-export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Exports
 *
 * Storico di tutti gli export generati (quando, da quale documento, con che sintesi), dal più recente; ordinabile con `sort`. Usalo anche per monitorare un export in generazione. Richiede un account autenticato.
 */
export const poListExports = <ThrowOnError extends boolean = true>(options: Options<PoListExportsData, ThrowOnError>) => (options.client ?? client).post<PoListExportsResponses, PoListExportsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-exports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Export Download
 *
 * Restituisce i link di download temporanei di un export completato (Excel e CSV). I link scadono dopo pochi minuti: richiedili al momento del download. Richiede un account autenticato.
 */
export const poGetExportDownload = <ThrowOnError extends boolean = true>(options: Options<PoGetExportDownloadData, ThrowOnError>) => (options.client ?? client).post<PoGetExportDownloadResponses, PoGetExportDownloadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-export-download',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Config
 *
 * Legge la configurazione di business corrente: editori in esclusiva, scorte di sicurezza, generazione schedulata e orari di sync. Con `includeHistory` restituisce anche la storia delle modifiche (chi e quando, non il contenuto). Se l'ultima versione salvata non è leggibile da questa release risponde `business_config_invalid`, con la versione e i campi da correggere: salvare una configurazione valida con `update-config` la sostituisce. Richiede un account autenticato.
 */
export const poGetConfig = <ThrowOnError extends boolean = true>(options: Options<PoGetConfigData, ThrowOnError>) => (options.client ?? client).post<PoGetConfigResponses, PoGetConfigErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Config
 *
 * Aggiorna la configurazione di business (invio completo, non parziale). La modifica ha effetto DALLE PROPOSTE SUCCESSIVE — i documenti già generati non cambiano — ed è tracciata: la storia di `get-config` mostra chi l'ha salvata e quando. Le scelte che influiscono su una proposta vengono citate nella sua motivazione. Funziona anche quando la versione corrente non è più leggibile (`business_config_invalid` su `get-config`): il salvataggio la sostituisce. Richiede un account autenticato.
 */
export const poUpdateConfig = <ThrowOnError extends boolean = true>(options: Options<PoUpdateConfigData, ThrowOnError>) => (options.client ?? client).post<PoUpdateConfigResponses, PoUpdateConfigErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/update-config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get System Status
 *
 * Stato del sistema per la dashboard: le tabelle su cui gira la prossima generazione con la loro freschezza e l'ultimo esito dell'agente per ciascuna, la data del dataset con le tabelle indispensabili che gli mancano e quelle rimaste indietro, se un aggiornamento dati è in corso, ultimo contatto e ultimo giro completo dell'agente, esito dell'ultima generazione, avanzamento dell'ultimo «Aggiorna dati ora» e presenza dell'adottato della campagna corrente. Risponde alla domanda “posso fidarmi di quello che vedo?”. Richiede un account autenticato.
 */
export const poGetSystemStatus = <ThrowOnError extends boolean = true>(options?: Options<PoGetSystemStatusData, ThrowOnError>) => (options?.client ?? client).post<PoGetSystemStatusResponses, PoGetSystemStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-system-status',
    ...options
});

/**
 * Refresh Data
 *
 * “Aggiorna dati ora”: accoda all'agente il comando di eseguire subito un giro di sincronizzazione. L'agente lo riceve al suo prossimo contatto (entro ~10 minuti) e i dati freschi compaiono dopo il tempo di upload: segui l'avanzamento su `refresh` di `get-system-status`. Se una richiesta è ancora in attesa, viene riaccodata invece di crearne un'altra. Richiede un account autenticato.
 */
export const poRefreshData = <ThrowOnError extends boolean = true>(options?: Options<PoRefreshDataData, ThrowOnError>) => (options?.client ?? client).post<PoRefreshDataResponses, PoRefreshDataErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/refresh-data',
    ...options
});

/**
 * Health Check
 *
 * Returns `Healthy` (200) when every essential service answered its latest check, `Unhealthy` (500) otherwise, including when the server can no longer serve database requests in time. Public. Right after startup it answers `Unhealthy` until the first checks complete.
 */
export const healthCheck = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/health-check',
    ...options
});

/**
 * Services
 *
 * Returns the health check of the server services
 */
export const healthCheckServices = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckServicesData, ThrowOnError>) => (options?.client ?? client).get<unknown, HealthCheckServicesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/health-check/services',
    ...options
});
